export default __webpack_public_path__ + "static/media/chemin de la lumière .a8b28bbb.jpg";